import React from 'react';
import { useGrades } from 'hooks';
import { connect } from 'react-redux';

import { Button } from '@mui/material';
import { Skeleton } from '@mui/material';
import { isEmpty } from '@lsgo/lsgo-common/utils';

const Tab = ({ selected, onTabClick, currentClass, allGrades }) => {
    const [state, actions] = useGrades();

    const { classGrades } = currentClass || { classGrades: [] };

    if (!state.loaded) {
        actions.load();
    }

    const gradeOptions = Object.keys(state.stages).map((k) => {
        return { label: state.stages[k], value: +k };
    });

    const shownGradeOptions =
        !isEmpty(classGrades) && !allGrades
            ? gradeOptions.filter((option) => classGrades.includes(option.value))
            : gradeOptions;
    return (
        <ul className='nav nav-tabs tabs-bordered mb-4'>
            {!state.loaded && <Skeleton style={{ height: 50, width: '100%' }} variant='rect'></Skeleton>}
            {/** Create tab list to allow switching between the grade you are viewing */}
            {state.loaded &&
                shownGradeOptions.map((grade) => {
                    return (
                        <li
                            className='nav-item'
                            key={`grade-${grade.value}`}
                            value={grade.value}
                            style={{ width: `${100 / shownGradeOptions.length}%` }}
                        >
                            <Button
                                className={`nav-link ${grade.value === selected ? 'active' : ''}`}
                                onClick={() => onTabClick(grade.value)}
                                style={{ width: '100%' }}
                                variant='outlined'
                                disableRipple
                            >
                                {grade.label}
                            </Button>
                        </li>
                    );
                })}
        </ul>
    );
};

const mapStateToProps = (state) => {
    return {
        currentClass:
            state.classes.classes &&
            state.classes.classes.find((c) => String(c.classId) === String(state.classes.currentClass)),
    };
};

export default connect(mapStateToProps)(Tab);
